import { Component, OnInit, Input, TemplateRef, } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';
import { MessagesService } from '../../_services/messages.service';
import { LoggerService } from '../../_services/logger.service';
import { Message } from '../../_models/message';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';

// Definindo tipos para melhor type safety
type SupportedLanguage = 'en' | 'pt' | 'fr' | 'es';
type LanguageNames = {
    portuguese: string;
    english: string;
    french: string;
    spanish: string;
};

@Component({
    /* tslint:disable */
    selector: '.changeLanguage',
    /* tslint:enable */
    styleUrls: ['./change-language.component.scss'],
    templateUrl: './change-language.component.html',
    standalone: true,
    imports: [CommonModule]
})
export class ChangeLanguageComponent implements OnInit {
    flag: string = '';
    flags: Record<string, string> = {
        "pt": "/assets/icon/flag/pt.svg",
        "en": "/assets/icon/flag/en.svg",
        "es": "/assets/icon/flag/es.svg",
        "fr": "/assets/icon/flag/french.svg" // Adicionando flag francesa para consistência
    };
    LangM!: BsModalRef;
    lang: SupportedLanguage;
    langSelected: string;
    portuguese: string;
    french: string;
    spanish: string;
    english: string;

    languageNames: Record<SupportedLanguage, LanguageNames> = {
        'pt': { 'portuguese': 'Português', 'english': 'Inglês', 'french': 'Francês', 'spanish': 'Espanhol' },
        'en': { 'portuguese': 'Portuguese', 'english': 'English', 'french': 'French', 'spanish': 'Spanish' },
        'fr': { 'portuguese': 'Portugais', 'english': 'Anglaise', 'french': 'Français', 'spanish': 'Espagnol' },
        'es': { 'portuguese': 'Portugués', 'english': 'Inglés', 'french': 'Francés', 'spanish': 'Español' }
    };

    languageMap: Record<SupportedLanguage, string> = {
        'en': 'English',
        'pt': 'Português',
        'fr': 'Français',
        'es': 'Español'
    };

    constructor(
        public translate: TranslateService,
        public bsModalRef: BsModalRef,
        private modalService: BsModalService,
        private router: Router,
    ) {
        // debugger
        let storelang = localStorage.getItem("lang") || 'pt';
        this.translate.use(storelang);
        
        // Validação para garantir que storelang é um idioma suportado
        this.lang = this.isValidLanguage(storelang) ? storelang : 'pt';
        
        // Por algum motivo, ainda desconhecido, quando o usuario da refresh na página
        // O header não consegue pegar as informações de linguagem, então para garantir
        // Colocamos manualmente
        this.langSelected = this.languageMap[this.lang];

        const names = this.languageNames[this.lang];
        this.portuguese = names.portuguese;
        this.english = names.english;
        this.french = names.french;
        this.spanish = names.spanish;

    }

    LangModal(Template: TemplateRef<any>) {
        this.LangM = this.modalService.show(Template, { class: 'modal-dialog ' });
    }

    changLang(lang: string) {
        this.translate.setDefaultLang(lang)
        localStorage.setItem("lang", lang);
        // this.router.navigate(['/empty']);
        this.translate.use(lang);
        // this.router.navigate(['/']);
        window.location.reload();
    }

    hideMl() {
        this.LangM.hide();
    }

    // Método auxiliar para validar se um idioma é suportado
    private isValidLanguage(lang: string): lang is SupportedLanguage {
        return ['en', 'pt', 'fr', 'es'].includes(lang);
    }

    public ngOnInit() {

    }
}
